// extracted by mini-css-extract-plugin
export default {"main_btn":"Button_main_btn__PvM-o"};